var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 347.696 144.247 C 311.449 105.597 268.98 95.62 257.76 93.584 C 265.322 70.384 277.002 35.897 279.911 30.794 C 281.793 30.525 283.688 30.402 285.584 30.424 C 293.828 30.424 311.482 32.372 337.045 45.442 C 373.964 64.314 383.776 85.542 385.722 90.734 L 347.696 144.247 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285.584 32.97 C 293.65 32.97 310.945 34.891 336.095 47.758 C 369.445 64.835 380.218 83.925 383.082 90.377 L 347.484 140.531 C 329.875 122.506 309.316 108.607 286.982 99.629 C 278.468 96.143 269.721 93.449 260.825 91.573 C 269.182 66.032 278.267 39.741 281.321 33.173 C 282.316 33.072 283.748 32.97 285.605 32.97 L 285.584 32.97 Z M 285.605 27.88 C 283.332 27.826 281.059 28.004 278.815 28.415 C 276.196 29.407 254.716 95.658 254.716 95.658 C 254.716 95.658 305.698 101.576 347.931 147.988 L 388.206 91.204 C 388.206 91.204 381.494 65.422 337.862 43.126 C 312.321 30.056 294.521 27.854 285.516 27.854 L 285.605 27.88 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262.179 100.813 C 262.179 100.813 312.311 106.565 343.187 138.825",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 305.451 98.025 L 324.158 56.666 L 343.378 99.795 L 305.451 98.025 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 309.088 97.44 L 327.793 56.081 L 347.013 99.209 L 309.088 97.44 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291.546 25.36 C 291.546 25.36 347.774 31.163 382.679 78.352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 320.264 208.639 C 317.176 206.094 315.152 204.325 315.152 204.325 C 316.002 203.053 329.527 186.649 337.359 173.44 C 337.359 173.44 321.518 209.696 320.264 208.639 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 128.634 89.181 C 130.144 92.044 130.804 90.898 135.155 90.453 C 139.508 90.008 145.706 93.686 147.876 99.781 C 150.046 105.877 149.386 106.82 148.211 107.582 C 147.037 108.346 138.68 109.492 138.344 111.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 241.37 399.007 L 237.465 391.512 L 223.638 417.74 L 227.264 420.922 L 241.37 399.007 Z",
    fill: "#F9865F",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 149.532 334.042 C 149.532 334.042 142.361 320.793 145.437 314.291 L 168.304 317.078 L 149.532 334.042 Z",
    fill: "#F9865F",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 149.532 334.042 L 150.897 337.63 L 146.68 356.363 C 146.412 357.52 146.438 358.739 146.753 359.879 C 147.068 361.021 147.658 362.038 148.458 362.815 L 169.368 327.653 C 170.326 326.035 170.746 324.081 170.55 322.142 C 170.356 320.204 169.559 318.408 168.304 317.078 L 163.628 312.14 L 149.532 334.042 Z",
    fill: "black",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 138.345 111.451 C 144.889 111.273 153.191 110.802 151.524 105.088 C 149.856 99.375 143.692 85.274 129.539 89.511 C 129.539 89.511 124.561 94.233 130.782 102.734 C 137.002 111.235 138.345 111.451 138.345 111.451 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.483 317.332 C 171.483 317.332 160.294 279.791 169.759 263.311 C 177.59 249.707 203.075 271.824 206.565 274.764 L 224.812 237.324 C 224.812 237.324 220.606 230.605 210.269 224.025 C 199.932 217.446 157.206 197.746 137.125 233.785 C 129.708 247.098 129.595 304.251 143.837 326.152 L 171.483 317.332 Z",
    style: {
      fill: "rgb(41, 40, 38)",
      stroke: "rgb(247, 255, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.483 317.332 C 171.483 317.332 160.294 279.791 169.759 263.311 C 177.59 249.706 203.075 271.824 206.565 274.764",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 224.812 237.324 C 216.512 247.263 191.91 295.672 186.373 318.77 C 178.977 349.72 181.763 375.389 222.44 425.668 L 242.097 393.09 C 242.097 393.09 228.269 369.216 230.91 346.705 C 234.646 314.138 255.018 282.564 265.322 262.534 L 224.812 237.324 Z",
    style: {
      fill: "rgb(41, 40, 38)",
      stroke: "rgb(241, 255, 254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 227.934 241.523 L 260.634 270.729 L 270.413 253.829 L 227.934 241.523 Z",
    fill: "#8C3C6C",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415.794 210.828 C 420.895 212.075 424.781 214.286 427.452 217.458 C 430.126 220.64 428.917 222.295 427.944 223.262 C 426.97 224.229 423.199 223.121 419.922 219.812 C 416.645 216.504 415.794 210.828 415.794 210.828 Z",
    fill: "#FF8A66",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 315.152 204.325 C 316.002 203.053 329.527 186.649 337.359 173.44 C 337.359 173.44 361.02 203.6 363.593 204.581 C 364.544 204.936 370.306 204.847 377.556 204.771 C 389.728 204.619 405.915 204.479 409.496 206.527 C 415.202 209.759 418.624 211.388 420.045 215.932 C 421.467 220.474 422.037 223.44 418.624 223.707 C 414.631 224.038 412.068 218.196 412.068 218.196 C 408.307 220.495 404.39 222.448 400.355 224.038 C 400.355 224.038 370.027 237.426 349.755 230.948 C 344.239 229.18 315.152 204.325 315.152 204.325 Z",
    fill: "#F9865F",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 131.308 83.849 C 128.712 84.982 127.124 86.33 128.634 89.181 C 130.144 92.032 130.804 90.899 135.155 90.454 C 139.508 90.008 145.706 93.686 147.876 99.781 C 150.046 105.878 149.386 106.82 148.211 107.583 C 147.037 108.346 138.68 109.492 138.345 111.4 C 138.009 113.31 141.701 118.921 149.432 118.552 L 151.265 118.171 C 151.265 118.171 167.454 136.153 169.804 138.813 C 172.153 141.472 189.359 154.745 198.891 157.443 C 206.096 159.492 220.707 156.858 229.478 154.898 C 233.74 153.944 236.637 153.167 236.637 153.167 C 236.637 153.167 230.049 139.665 228.706 118.921 C 228.706 118.921 212.954 121.798 202.482 124.419 C 202.482 124.419 178.049 108.919 166.168 102.06 C 166.168 102.06 155.785 87.603 150.93 85.694 C 146.075 83.785 134.82 82.334 131.308 83.849 Z",
    fill: "#F9865F",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 229.433 154.961 C 233.695 154.007 236.593 153.231 236.593 153.231 C 236.593 153.231 228.616 141.777 227.285 121.059 C 227.285 121.059 223.682 125.475 224.802 137.221 C 226.211 152.06 229.433 154.961 229.433 154.961 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226.95 118.731 C 226.95 118.731 227.173 144.093 233.147 154.668 L 235.284 153.689 C 235.284 153.689 207.148 191.141 198.041 215.614 C 196.553 219.622 256.473 263.158 265.322 262.547 C 265.322 262.547 294.521 211.859 304.479 196.83 L 315.219 206.299 C 315.219 206.299 336.263 182.043 337.393 173.44 C 337.393 173.44 317.064 145.303 300.473 137.057 C 283.882 128.81 268.903 114.709 251.036 115.155 C 235.575 115.423 226.95 118.731 226.95 118.731 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 315.174 206.298 L 304.445 196.83 L 306.157 191.536 L 315.174 206.298 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 331.508 106.029 C 329.629 112.686 324.202 131.914 318.15 134.282 C 312.098 136.649 305.843 133.684 305.843 133.684 L 299.399 137.424 C 298.684 139.881 293.594 141.993 287.027 142.287 C 282.16 142.502 279.195 135.389 280.638 130.247 C 281.298 127.88 283.77 116.249 283.77 116.249 C 283.77 116.249 288.984 94.411 293.839 89.906 C 298.695 85.401 303.147 80.921 315.957 86.814 C 335.468 95.824 331.508 106.029 331.508 106.029 Z",
    fill: "#F9865F",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 292.609 106.984 C 291.748 111.056 288.022 119.227 285.572 117.751 C 283.122 116.275 282.271 112.533 283.994 105.343 C 285.717 98.152 287.16 81.838 292.038 78.898 C 296.916 75.959 299.075 79.382 299.075 79.382 C 299.075 79.382 296.916 67.47 303.236 65.829 C 303.236 65.829 305.385 64.695 304.524 72.854 C 305.36 70.61 306.832 68.75 308.705 67.567 C 310.578 66.384 312.745 65.947 314.861 66.325 C 322.693 67.305 325.478 79.878 325.478 79.878 C 325.704 78.839 326.246 77.925 327.008 77.296 C 327.769 76.668 328.701 76.365 329.64 76.442 C 333.231 76.442 338.689 82.488 337.393 89.168 C 337.393 89.168 346.577 85.898 351.455 94.259 C 356.333 102.62 355.762 111.732 343.993 115.32 C 331.687 119.075 331.799 102.748 329.93 100.621 C 328.062 98.496 326.059 96.053 319.167 98.993 C 312.276 101.932 305.094 93.279 305.094 93.279 C 305.094 93.279 303.975 103.727 302.801 104.731 C 301.625 105.737 299.355 107.023 299.925 102.123 C 300.495 97.224 301.223 97.707 300.786 96.409 C 300.35 95.111 298.415 90.975 294.332 94.615 C 289.745 98.611 292.609 106.984 292.609 106.984 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 294.567 108.791 C 291.826 106.246 289.923 101.563 292.329 96.956 C 294.734 92.35 298.684 91.726 299.881 93.469 C 301.078 95.213 301.547 98.152 300.417 101.639",
    stroke: "#2A1E33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 227.274 420.922 L 228.639 424.498 L 224.421 443.23 C 224.154 444.387 224.181 445.607 224.495 446.747 C 224.809 447.889 225.4 448.906 226.2 449.683 L 247.087 414.521 C 248.046 412.902 248.465 410.948 248.27 409.01 C 248.075 407.071 247.278 405.276 246.024 403.946 L 241.348 399.007 L 227.274 420.922 Z",
    fill: "black",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 299.075 79.382 C 299.075 79.382 297.464 73.464 292.665 71.899",
    stroke: "#2A1E33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 197.324 213.82 L 255.254 121.772",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279.139 128.211 C 277.047 131.304 276.097 144.59 285.706 145.443 C 291.187 146.063 296.699 144.686 301.448 141.51",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150.875 85.758 C 150.875 85.758 157.497 95.723 158.538 99.272",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 398.834 219.419 C 398.834 219.419 403.308 223.554 412.068 218.145 C 415.257 216.198 412.986 211.605 408.937 212.75 C 404.887 213.895 400.098 212.177 400.098 212.177",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 417.316 211.401 C 417.316 211.401 421.556 217.039 421.443 220.386",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 354.844 210.79 C 354.844 210.79 358.682 204.974 363.593 204.581",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 193.017 133.874 C 193.017 133.874 195.255 125.933 202.437 124.483",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 212.473 254.364 L 203.904 272.957 C 203.904 272.957 175.667 327.31 185.254 362.433",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237.487 316.721 L 265.266 262.547 C 265.266 262.547 301.682 202.468 305.407 194.055 L 318.262 167.013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 201.218 219.596 C 201.218 219.596 250.633 260.575 265.277 262.547",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 226.95 118.731 C 226.95 118.731 226.95 144.45 233.002 154.987",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.771 169.367 C 334.215 179.955 313.596 202.213 313.596 202.213",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181.874 301.361 C 183.494 301.361 184.806 299.869 184.806 298.027 C 184.806 296.185 183.494 294.693 181.874 294.693 C 180.256 294.693 178.944 296.185 178.944 298.027 C 178.944 299.869 180.256 301.361 181.874 301.361 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 457.133 369.738 L 455.51 356.974 L 465.075 364.214 L 460.075 365.449 L 457.133 369.738 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139.688 151.831 C 121.552 133.62 91.581 179.014 201.218 323.504 C 264.483 406.86 314.212 414.329 320.925 385.327 C 333.007 333.303 289.375 320.158 305.62 340.531 C 329.225 370.158 396.361 376.419 446.403 348.778 C 495.774 321.494 465.423 279.129 462.357 276.648",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 447.231 351.845 C 448.85 351.845 450.162 350.352 450.162 348.511 C 450.162 346.669 448.85 345.176 447.231 345.176 C 445.612 345.176 444.3 346.669 444.3 348.511 C 444.3 350.352 445.612 351.845 447.231 351.845 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 404.539 375.757 L 491.5 319.992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 141.5 157.863 C 143.118 157.863 144.431 156.37 144.431 154.528 C 144.431 152.687 143.118 151.194 141.5 151.194 C 139.881 151.194 138.568 152.687 138.568 154.528 C 138.568 156.37 139.881 157.863 141.5 157.863 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.309 92.782 C 219.789 92.782 222.608 89.575 222.608 85.618 C 222.608 81.66 219.789 78.453 216.309 78.453 C 212.832 78.453 210.012 81.66 210.012 85.618 C 210.012 89.575 212.832 92.782 216.309 92.782 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102.108 31.011 C 101.559 31.008 101.021 31.19 100.563 31.536 C 100.106 31.881 99.749 32.374 99.537 32.95 C 99.324 33.526 99.268 34.161 99.374 34.774 C 99.48 35.387 99.743 35.952 100.13 36.393 C 100.519 36.836 101.013 37.139 101.551 37.261 C 102.09 37.384 102.649 37.322 103.155 37.083 C 103.663 36.845 104.098 36.44 104.403 35.922 C 104.708 35.402 104.872 34.792 104.872 34.167 C 104.872 33.331 104.58 32.531 104.063 31.939 C 103.545 31.348 102.841 31.013 102.108 31.011 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 472.85 421.927 C 474.377 421.927 475.614 420.52 475.614 418.784 C 475.614 417.047 474.377 415.641 472.85 415.641 C 471.325 415.641 470.087 417.047 470.087 418.784 C 470.087 420.52 471.325 421.927 472.85 421.927 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 423.412 276.634 L 393.643 260.765 C 393.117 260.47 392.677 260.012 392.372 259.445 C 392.067 258.875 391.909 258.221 391.918 257.556 C 391.926 256.89 392.099 256.241 392.418 255.682 C 392.738 255.124 393.189 254.681 393.722 254.402 L 449.055 226.711 C 449.442 226.515 449.862 226.415 450.285 226.415 C 450.708 226.415 451.129 226.515 451.516 226.711 L 489.553 245.265 L 423.412 276.634 Z",
    style: {
      fill: "rgb(74, 71, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 421.612 224.458 C 421.679 238.456 423.446 276.635 423.446 276.635 L 489.586 245.215 L 488.099 192.084 C 488.079 191.33 487.897 190.593 487.566 189.939 C 487.235 189.286 486.769 188.736 486.207 188.339 C 485.643 187.94 485.003 187.706 484.341 187.658 C 483.68 187.61 483.018 187.749 482.416 188.062 L 425.483 217.586 C 424.321 218.181 423.337 219.148 422.649 220.368 C 421.962 221.588 421.601 223.009 421.612 224.458 Z",
    style: {
      fill: "rgb(41, 40, 38)",
      stroke: "rgb(249, 245, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 423.412 276.634 L 489.553 245.215 L 488.066 192.083 C 488.066 192.083 487.629 186.28 482.382 188.061",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 455.42 238.443 L 459.884 226.443",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 459.884 238.443 L 464.349 226.443",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 114.023 369.394 C 115.549 369.394 116.786 367.987 116.786 366.25 C 116.786 364.515 115.549 363.108 114.023 363.108 C 112.497 363.108 111.26 364.515 111.26 366.25 C 111.26 367.987 112.497 369.394 114.023 369.394 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347.315 386.23 C 349.441 386.23 351.164 384.27 351.164 381.853 C 351.164 379.436 349.441 377.475 347.315 377.475 C 345.19 377.475 343.467 379.436 343.467 381.853 C 343.467 384.27 345.19 386.23 347.315 386.23 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 142.707 412.942 C 153.662 418.669 165.59 421.58 177.646 421.469 C 177.87 421.471 178.091 421.526 178.294 421.632 C 178.498 421.738 178.68 421.891 178.828 422.082 C 178.976 422.273 179.086 422.497 179.152 422.741 C 179.219 422.984 179.24 423.24 179.212 423.492 L 176.797 445.279 C 176.748 445.657 176.595 446.008 176.359 446.28 C 176.124 446.553 175.819 446.732 175.486 446.793 C 170.586 447.85 150.875 450.93 136.085 436.613 C 135.859 436.393 135.694 436.107 135.606 435.784 C 135.52 435.462 135.515 435.118 135.593 434.793 L 140.47 414.011 C 140.538 413.759 140.653 413.528 140.808 413.332 C 140.964 413.137 141.155 412.982 141.369 412.88 C 141.583 412.777 141.812 412.73 142.044 412.741 C 142.276 412.753 142.502 412.821 142.707 412.942 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.442 419.305 C 144.442 419.305 152.966 432.935 156.009 434.895 C 159.053 436.854 175.476 425.707 175.476 425.707",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 164.054 433.012 L 173.014 443.485",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 151.601 430.989 L 141.119 434.233",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 417.069 155.101 L 407.056 155.101 L 407.056 166.491 L 417.069 166.491 L 417.069 155.101 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.41 308.691 L 411.386 314.558 L 414.363 320.425 L 408.41 320.425 L 402.47 320.425 L 405.435 314.558 L 408.41 308.691 Z",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.824 48.98 L 168.606 22.357 C 168.517 19.812 169.411 19.086 170.755 18.743 C 177.109 17.152 196.485 12.253 217.44 19.316 C 220.158 20.232 220.069 21.86 220.024 23.336 L 219.275 48.713 C 219.22 49.187 219.079 49.642 218.86 50.051 C 218.64 50.459 218.349 50.81 218.004 51.083 C 217.657 51.355 217.266 51.542 216.852 51.631 C 216.44 51.721 216.014 51.711 215.605 51.601 C 207.989 50.564 200.318 50.139 192.649 50.329 C 185.273 50.292 177.907 50.969 170.632 52.351 C 168.55 52.797 167.768 51.067 167.824 48.98 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174.894 45.162 L 187.134 28.872 L 200.67 44.08 C 195.994 42.286 174.894 45.162 174.894 45.162 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 194.618 36.355 L 204.508 27.345 L 212.842 34.115 L 213.155 44.691 L 200.658 44.004",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.181 27.597 C 180.294 26.318 179.314 25.157 177.994 25.005 C 176.671 24.853 175.508 25.767 175.394 27.046 C 175.281 28.326 176.26 29.487 177.582 29.639 C 178.903 29.791 180.067 28.877 180.181 27.597 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 404.327 394.757 L 412.528 411.989 C 413.389 413.528 413.087 414.406 412.337 415.195 C 408.825 418.898 398.118 430.174 382.456 434.576 C 380.431 435.149 379.949 434.067 379.503 433.112 L 371.671 416.684 C 371.552 416.359 371.494 416.009 371.502 415.657 C 371.508 415.305 371.579 414.958 371.709 414.639 C 371.839 414.319 372.027 414.035 372.259 413.801 C 372.491 413.569 372.763 413.393 373.058 413.286 C 378.236 410.729 383.247 407.752 388.049 404.378 C 392.78 401.313 397.273 397.791 401.474 393.853 C 402.593 392.581 403.711 393.409 404.327 394.757 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 401.105 400.216 L 398.655 415.73 L 385.097 411.797 C 388.619 410.932 401.105 400.216 401.105 400.216 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 391.427 414.113 L 388.082 424.014 L 380.587 423.238 L 376.929 416.645 L 385.085 411.797",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 405.653 414.38 C 406.541 413.919 406.982 412.85 406.638 411.993 C 406.293 411.137 405.295 410.817 404.407 411.279 C 403.52 411.74 403.078 412.808 403.422 413.665 C 403.767 414.522 404.766 414.841 405.653 414.38 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 364.387 100.557 L 397.715 129.574 C 397.889 129.725 398.087 129.836 398.298 129.9 C 398.51 129.964 398.73 129.979 398.946 129.945 C 399.163 129.91 399.372 129.827 399.56 129.699 C 399.748 129.573 399.912 129.404 400.042 129.204 L 405.076 121.441 C 405.324 121.054 405.43 120.573 405.374 120.099 C 405.318 119.626 405.103 119.195 404.774 118.896 L 371.917 88.977 C 371.742 88.819 371.543 88.703 371.328 88.636 C 371.112 88.568 370.888 88.552 370.666 88.586 C 370.446 88.62 370.234 88.705 370.043 88.836 C 369.852 88.967 369.686 89.14 369.557 89.346 L 364.052 98 C 363.805 98.392 363.702 98.879 363.765 99.357 C 363.827 99.833 364.05 100.264 364.387 100.557 Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 366.849 99.26 L 374.926 105.712 L 379.703 99.235 L 371.614 91.56 L 366.849 99.26 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.969 108.232 L 386.069 115.536 L 390.41 109.466 L 382.254 101.945 L 377.969 108.232 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 388.787 118.336 L 396.877 124.788 L 400.724 119.163 L 393.072 111.871 L 388.787 118.336 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 430.897 59.987 L 438.493 132.526 C 438.528 132.907 438.629 133.277 438.793 133.613 C 438.955 133.949 439.176 134.245 439.44 134.483 C 439.706 134.721 440.01 134.895 440.336 134.996 C 440.661 135.096 441.001 135.123 441.335 135.07 L 454.201 133.06 C 454.846 132.962 455.433 132.581 455.836 131.999 C 456.239 131.417 456.427 130.679 456.36 129.942 L 450.129 56.971 C 450.095 56.586 449.993 56.212 449.827 55.873 C 449.663 55.533 449.439 55.237 449.17 54.999 C 448.902 54.76 448.593 54.588 448.263 54.489 C 447.934 54.391 447.591 54.369 447.254 54.426 L 433.035 56.793 C 432.381 56.901 431.79 57.296 431.391 57.893 C 430.992 58.491 430.814 59.243 430.897 59.987 Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 434.779 61.68 L 437.185 78.657 L 448.529 77.702 L 447.287 59.415 L 434.779 61.68 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 438.001 85.147 L 439.601 103.052 L 450.095 101.983 L 448.641 83.785 L 438.001 85.147 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 439.803 109.454 L 442.208 126.43 L 451.751 125.234 L 450.599 107.888 L 439.803 109.454 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 414.318 75.437 L 435.35 145.773 C 435.436 146.06 435.57 146.324 435.746 146.55 C 435.923 146.778 436.136 146.962 436.376 147.094 C 436.616 147.225 436.875 147.301 437.141 147.316 C 437.407 147.332 437.672 147.288 437.923 147.185 L 451.102 141.791 C 451.589 141.588 451.988 141.18 452.217 140.653 C 452.446 140.123 452.488 139.514 452.333 138.953 L 432.586 67.928 C 432.504 67.633 432.369 67.361 432.191 67.127 C 432.013 66.893 431.795 66.702 431.551 66.566 C 431.306 66.431 431.039 66.353 430.768 66.338 C 430.495 66.323 430.224 66.37 429.969 66.478 L 415.515 72.573 C 415.023 72.775 414.621 73.189 414.398 73.725 C 414.174 74.26 414.146 74.877 414.318 75.437 Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 418.58 76.722 L 424.039 92.77 L 434.958 89.142 L 430.405 71.542 L 418.58 76.722 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 426.031 98.917 L 430.864 116.058 L 440.932 112.52 L 436.189 95.06 L 426.031 98.917 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.229 122.269 L 437.687 138.303 L 446.806 134.867 L 442.51 118.171 L 432.229 122.269 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 106.267 107.264 L 107.942 109.35 C 108.283 109.773 108.46 110.333 108.438 110.907 C 108.415 111.48 108.193 112.019 107.821 112.406 L 105.078 115.256 C 104.706 115.642 104.214 115.846 103.71 115.819 C 103.206 115.794 102.732 115.541 102.39 115.118 L 100.717 113.031 L 106.267 107.264 Z",
    fill: "#91BA83",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91.183 103.209 L 99.084 113.047 C 99.492 113.555 100.185 113.591 100.632 113.127 L 106.092 107.453 C 106.54 106.989 106.571 106.2 106.163 105.692 L 98.263 95.854 C 97.855 95.345 97.161 95.31 96.714 95.774 L 91.253 101.448 C 90.807 101.912 90.775 102.7 91.183 103.209 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.933 147.911 L 73.009 147.911 L 73.009 158.219 L 82.933 158.219 L 82.933 147.911 Z",
    fill: "#FF6D66",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.009 141.281 L 73.009 147.91 L 67.079 147.91",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 409.888 31.507 L 399.963 31.507 L 399.963 41.814 L 409.888 41.814 L 409.888 31.507 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 399.963 24.876 L 399.963 31.507 L 394.035 31.507",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 131.375 95.225 C 28.45 46.714 -50.713 140.149 143.222 283.214 C 158.493 294.489 181.92 298.485 181.92 298.485",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.74 101.817 C 38.358 101.817 39.671 100.325 39.671 98.484 C 39.671 96.642 38.358 95.149 36.74 95.149 C 35.121 95.149 33.809 96.642 33.809 98.484 C 33.809 100.325 35.121 101.817 36.74 101.817 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.079 80.172 L 21.29 76.658 L 28.662 81.469 L 32.377 94.488 L 21.043 89.092 L 18.079 80.172 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.29 76.658 L 18.079 80.171 L 16.277 77.688 L 19.354 74.329 L 21.29 76.658 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.377 94.488 L 25.004 85.287",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.187 328.111 L 58.174 374.993 C 58.218 375.237 58.303 375.469 58.424 375.675 C 58.545 375.88 58.702 376.058 58.884 376.195 C 59.066 376.332 59.27 376.428 59.485 376.475 C 59.698 376.521 59.919 376.52 60.132 376.469 L 68.433 374.459 C 68.849 374.358 69.214 374.077 69.453 373.676 C 69.69 373.275 69.783 372.785 69.709 372.308 L 62.616 325.133 C 62.578 324.885 62.495 324.646 62.373 324.434 C 62.252 324.222 62.094 324.041 61.909 323.9 C 61.724 323.76 61.516 323.664 61.296 323.617 C 61.078 323.571 60.853 323.577 60.636 323.632 L 51.474 325.948 C 51.264 325.994 51.064 326.085 50.886 326.22 C 50.708 326.353 50.556 326.525 50.436 326.726 C 50.317 326.927 50.233 327.153 50.19 327.39 C 50.148 327.628 50.146 327.873 50.187 328.111 Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.816 329.002 L 55.098 339.933 L 62.438 338.7 L 60.871 326.851 L 52.816 329.002 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.903 344.121 L 57.694 355.689 L 64.485 354.429 L 62.773 342.644 L 55.903 344.121 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.096 359.85 L 60.367 370.781 L 66.532 369.471 L 65.067 358.246 L 58.096 359.85 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279.206 445.584 L 312.993 435.302 L 314.29 439.464 L 280.112 449.555 L 279.206 445.584 Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 274.507 440.214 L 275.492 443.702",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 273.556 442.491 L 276.409 441.372",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272.874 453.538 L 274.709 460.131",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 271.308 457.713 L 276.387 455.88",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265.144 442.67 L 267.549 451.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 262.761 448.105 L 269.876 445.521",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.779 27.968 L 11.4 16.986 L 12.284 14.212 L 33.797 25.474 L 32.779 27.968 Z",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.215 33.034 L 34.01 30.743",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.559 32.309 L 32.657 31.507",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.034 26.9 L 40.544 22.598",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.405 25.487 L 38.093 23.986",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.988 36.279 L 41.003 30.591",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.255 34.612 L 37.601 32.512",
    stroke: "white",
    strokeWidth: 0.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 112.714 233.43 C 97.633 221.086 82.821 201.895 89.321 182.182 C 89.321 182.182 99.714 174.305 116.171 184.155 L 132.639 194.055 L 112.714 233.43 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105.878 315.678 C 99.087 312.025 70.135 294.871 64.977 265.563 C 60.502 240.264 77.552 206.12 86.076 191.027 C 85.528 211.045 103.205 227.996 111.729 234.97 C 118.984 241.037 126.987 245.849 135.481 249.249 L 105.878 315.678 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.779 196.982 C 86.624 210.294 95.552 224.077 110.746 236.522 C 117.6 242.277 125.132 246.908 133.12 250.279 L 105.152 313.146 C 96.604 308.309 71.354 291.944 66.644 265.194 C 62.74 242.962 75.985 213.476 84.802 196.982 L 84.779 196.982 Z M 89.343 182.182 C 89.343 182.182 57.291 231.458 63.355 265.945 C 69.419 300.433 106.672 318.122 106.672 318.122 L 137.852 248.129 C 128.108 244.069 121.776 240.76 112.737 233.354 C 97.656 221.009 82.844 201.819 89.343 182.106 L 89.343 182.182 Z",
    style: {
      stroke: "rgb(249, 211, 66)",
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.897 210.816 C 81.836 217.225 84.064 223.302 87.405 228.573 C 90.746 233.844 95.112 238.166 100.161 241.205",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109.469 248.281 L 126.866 258.882",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.38 239.092 C 83.38 239.092 88.974 253.231 106.986 262.42",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.082 241.206 C 69.082 241.206 69.709 256.057 78.402 261.007",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.974 189.615 C 88.974 189.615 87.362 208.704 112.713 233.43",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.293 193.152 C 98.293 193.152 106.37 192.439 118.174 202.341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.255 254.008 C 59.741 263.463 60.781 297.734 104.412 319.598",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 338.902 234.944 L 320.398 277.131 C 320.398 277.131 332.951 282.386 323.139 298.765 C 323.139 298.765 346.342 309.709 361.524 281.293 C 376.706 252.876 338.902 234.944 338.902 234.944 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 296.546 363.883 C 287.183 363.883 277.304 359.531 267.157 350.941 L 301.772 285.683 L 322.368 300.432 L 322.501 300.495 C 326.102 301.999 329.91 302.749 333.745 302.71 C 340.25 302.756 346.602 300.471 351.903 296.182 L 326.596 345.494 C 326.54 345.585 315.644 363.922 296.546 363.922 L 296.546 363.883 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 302.331 288.355 L 321.349 301.985 L 321.595 302.162 L 321.853 302.278 C 325.658 303.878 329.687 304.68 333.745 304.645 C 338.407 304.665 343.021 303.563 347.282 301.412 L 325.198 344.388 C 324.481 345.585 314.234 361.975 296.558 361.975 C 287.932 361.975 278.803 358.094 269.384 350.432 L 302.331 288.355 Z M 361.524 281.28 C 352.942 297.34 341.811 300.826 333.745 300.826 C 330.13 300.861 326.538 300.159 323.139 298.752 L 301.223 283.061 L 264.987 351.426 C 277.091 362.038 287.686 365.856 296.558 365.856 C 316.819 365.856 328.05 346.488 328.05 346.488 L 361.524 281.343 L 361.524 281.28 Z",
    style: {
      fill: "rgb(249, 211, 66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 320.398 277.131 C 320.398 277.131 334.204 282.679 323.139 298.765",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.786 281.585 C 300.786 281.585 319.593 301.182 329.998 301.042 C 340.402 300.903 352.618 298.104 359.812 283.977",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 303.103 306.934 C 303.103 306.934 316.002 319.965 330.434 315.78",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 316.65 326.407 C 316.65 326.407 323.419 332.171 332.883 326.711",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 285.505 334.45 C 285.505 334.45 301.168 352.126 325.724 340.469",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 294.007 317.206 C 294.007 317.206 300.384 322.397 304.377 324.052",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 342.079 247.187 C 342.079 247.187 356.344 252.493 358.056 273.911",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 349.25 273.644 C 349.25 273.644 355.818 285.212 344.72 296.767",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 266.262 348.244 C 266.262 348.244 302.062 399.249 328.073 339.603",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.73 221.773 L 16.076 221.773",
    stroke: "#FF6D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 472.85 107.531 L 481.196 107.531",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "rgb(249, 211, 66)",
      stroke: "rgb(41, 40, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248.933 42.374 L 257.289 42.374",
    stroke: "#FAD8B0",
    strokeMiterlimit: 10,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 488.793 156.794 L 497.004 158.474",
    stroke: "#FAD8B0",
    strokeMiterlimit: 10,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160.797 393.79 L 169.155 393.79",
    stroke: "#A0C6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.a22ab7a2ea59849c2ea9cd97ba3342f0.svg";
export { ForwardRef as ReactComponent };